import { useState, useCallback } from 'react';
import { getUILoc } from '../utils/cardUtils.js';
import { getFromStorage, saveToStorage } from '../utils/localStorage.js';
import { MIN_DECK_SIZE, MAX_DECK_SIZE } from '../gameLogic/constants.js';

const STORAGE_KEY = 'deckBuilderTutorialSeen';

const useDeckBuilderTutorial = () => {
    const [isActive, setIsActive] = useState(() => {
        const seen = getFromStorage(STORAGE_KEY);
        return seen === null || seen === false;
    });
    const [currentStep, setCurrentStep] = useState(() => {
        const seen = getFromStorage(STORAGE_KEY);
        return (seen === null || seen === false) ? 1 : 0;
    });

    const completeTutorial = useCallback(() => {
        setIsActive(false);
        setCurrentStep(0);
        saveToStorage(STORAGE_KEY, true);
    }, []);

    const nextStep = useCallback(() => {
        if (currentStep >= 5) {
            completeTutorial();
        } else {
            setCurrentStep(prev => prev + 1);
        }
    }, [currentStep, completeTutorial]);

    const getTutorialData = () => {
        if (!isActive) return null;

        const data = {
            1: {
                text: getUILoc('UI.DECK_BUILDER_TUTORIAL.STEP_1'),
                targetId: null,
            },
            2: {
                text: getUILoc('UI.DECK_BUILDER_TUTORIAL.STEP_2', { min: MIN_DECK_SIZE, max: MAX_DECK_SIZE }),
                targetId: 'empty-deck-placeholder',
            },
            3: {
                text: getUILoc('UI.DECK_BUILDER_TUTORIAL.STEP_3'),
                targetId: 'card-library-grid',
            },
            4: {
                text: getUILoc('UI.DECK_BUILDER_TUTORIAL.STEP_4'),
                targetId: 'first-library-card',
            },
            5: {
                text: getUILoc('UI.DECK_BUILDER_TUTORIAL.STEP_5'),
                targetId: 'help-button-trigger',
            }
        };

        return data[currentStep] || null;
    };

    const restartTutorial = useCallback(() => {
        setIsActive(true);
        setCurrentStep(1);
    }, []);

    return {
        isActive,
        currentStep,
        tutorialData: getTutorialData(),
        nextStep,
        completeTutorial,
        restartTutorial
    };
};

export default useDeckBuilderTutorial;
